import { ACCOUNT_DETAILS_STATES_ENDPOINT, ADMIN_SUBSCRIBER_ACCOUNT_DETAILS } from '../endpoints';
import API from './../api';

export default {
    namespaced: true,

    state() {
        return {
            details: null,
            countryList: [],
            stateList: [],
            selectedCountry: null,
            selectedState: null,
            selectedPrefix: null
        };
    },

    getters: {
        details: (state) => {
            if(state.details && !state.details.client.address.phone) {
                state.details.client.address.phone = ''
            }
            return state.details
        },
        countriesOptions: (state) => state.countryList.map(item => ({
            value: item.id,
            text: item.name
        })),
        statesOptions: (state) => state.stateList.map(item => ({
            value: item.id,
            text: item.name
        }))
    },

    mutations: {
        gotDetails(state, data) {
            state.details = data
            state.selectedCountry = data.client.address.country.id
            state.selectedState = data.client.address.state?.id 
            state.selectedPrefix = data.client.title.id

        },
        gotCountries(state, data) {
            state.countryList = data
        },
        gotStates(state, data) {
            state.stateList = data.states
        },
        gotSelectedCountry(state, id) {
            state.selectedCountry = id
        },
        gotSelectedState(state, id) {
            state.selectedState = id
        },
        gotSelectedPrefix(state, id) {
            state.selectedPrefix = id
        }
    },

    actions: {
        async fetchDetails({commit, dispatch}, {id}) {
            const {data} = await API.get(ADMIN_SUBSCRIBER_ACCOUNT_DETAILS(id));
            commit('gotDetails', data);
            dispatch('fetchStates', {id: data.client.address.country.id})
        },
        async fetchCountries({commit}) {
            const {data} = await API.get(`${ADMIN_SUBSCRIBER_ACCOUNT_DETAILS()}countries/`);
            commit('gotCountries', data);
        },
        async fetchStates({commit}, {id, isCountryChanged}) {
            const {data} = await API.get(ACCOUNT_DETAILS_STATES_ENDPOINT(id));
            commit('gotStates', data);
            if(isCountryChanged && data.states) {
                commit('gotSelectedState', data.states[0].id)
            }
        },
        async onChangeCountry({commit, dispatch}, {id}) {
            commit('gotSelectedCountry', id)
            dispatch('fetchStates', {id, isCountryChanged: true})
        }
    },

};
